import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '@/store/store';
import { setChangeProccess } from '@/store/slices/claimsSlice';

import { useNavigate } from 'react-router';

import useStartet from '@/hooks/useStartet';
import useCases from '@/hooks/useCases';
import { useIsProcess } from '@/hooks/useIsProcess';

import Table from '@/components/Table/table';

const Focus = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { searchItem } = useSelector((state: RootState) => state.search);

  useEffect(() => {
    if (!searchItem || Object.keys(searchItem).length === 0) {
      navigate('/search');
    }
  }, [searchItem, navigate]);

  const { data: claims, isProcess } = useSelector(
    (state: RootState) => state.claims
  );
  const { columns: claimsColums, claimsData } = useIsProcess({
    claims,
    isProcess,
  });
  const { columns: startetColumns, data: startetData } = useStartet();
  const { columns: casesColumns, data: casesData } = useCases();

  let columns = [];
  let data = [];

  if (searchItem) {
    switch (searchItem.key) {
      case 'krav': {
        columns = claimsColums;
        data = searchItem.data || claimsData;
        break;
      }
      case 'startet': {
        columns = startetColumns;
        data = searchItem.data || startetData;
        break;
      }
      case 'sager': {
        columns = casesColumns;
        data = searchItem.data || casesData;
        break;
      }
    }
  }

  useEffect(() => {
    if (searchItem && searchItem.key === 'krav' && data.length > 0) {
      dispatch(setChangeProccess(!data[0].isMissingInformation));
    }
  }, [searchItem, data, dispatch]);

  return (
    <div className="mt-4">
      <Table data={data} columns={columns} isFocus={true} />
    </div>
  );
};

export default Focus;
